class FilazooFaq {
  constructor(section) {
    this.section = section;
    this.links = Array.from(section.querySelectorAll('[data-faq-category-link]'));
    this.groups = Array.from(section.querySelectorAll('[data-faq-category]'));

    if (!this.links.length || !this.groups.length) return;

    this.links.forEach((link) => {
      link.addEventListener('click', () => this.setActive(link));
    });

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((first, second) => first.boundingClientRect.top - second.boundingClientRect.top)[0];

          if (!visible) return;
          const link = this.links.find((item) => item.hash === `#${visible.target.id}`);
          if (link) this.setActive(link);
        },
        { rootMargin: '-15% 0px -70% 0px' }
      );

      this.groups.forEach((group) => this.observer.observe(group));
    }
  }

  setActive(activeLink) {
    this.links.forEach((link) => link.classList.toggle('is-active', link === activeLink));
  }
}

const initializeFilazooFaqs = (scope = document) => {
  scope.querySelectorAll('[data-filazoo-faq]').forEach((section) => {
    if (section.dataset.faqReady === 'true') return;
    section.dataset.faqReady = 'true';
    new FilazooFaq(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeFilazooFaqs());
} else {
  initializeFilazooFaqs();
}

document.addEventListener('shopify:section:load', (event) => initializeFilazooFaqs(event.target));
